import React, { useEffect, useRef, useState } from 'react';

interface DropdownItem {
    label: string;
    icon?: React.ReactNode;
    onClick: () => void;
}

interface DropdownProps {
    buttonLabel: string;
    items: DropdownItem[];
    buttonIconRight?: any;
    buttonIconLeft?: any;
    className?: string;
    leftIconClassName?: string;
    rightIconClassName?: string;
}

function Dropdown({ buttonLabel, items, buttonIconRight, buttonIconLeft, className, leftIconClassName, rightIconClassName }: DropdownProps) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={`relative   w-full ${className}`} ref={dropdownRef}>
            <button
                onClick={toggleDropdown}
                className="flex justify-between items-center  px-2 py-3 text-sm text-white bg-primary border-primary border-2 border-solid rounded outline-none w-full "
            >
                {buttonIconLeft && <img src={buttonIconLeft} alt='' className={leftIconClassName} />}
                {buttonLabel}
                {buttonIconRight && <img src={buttonIconRight} alt='' className={rightIconClassName} />}
            </button>
            {isOpen && (
                <div className="absolute right-0 z-10 mt-2 w-56 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                        {items.map((item, index) => (
                            <button
                                key={index}
                                onClick={item.onClick}
                                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                                {item.icon && <span className="mr-2">{item.icon}</span>}
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dropdown;